import { render, staticRenderFns } from "./StatsFormExpense.vue?vue&type=template&id=13a9187a"
import script from "./StatsFormExpense.vue?vue&type=script&lang=js"
export * from "./StatsFormExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports